import { Email, MarkEmailUnreadOutlined } from "@mui/icons-material";
import { Chip, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const filters = [
  { label: "AllConvos", value: "true", icon: <Email /> },
  { label: "UnReadConvos", value: "false", icon: <MarkEmailUnreadOutlined /> },
];

export default function ConversationFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  function handleSearchFilter(value) {
    searchParams.set("read_f", value);
    setSearchParams(searchParams);
  }

  const currentFilter = searchParams.get("read_f") ?? "true";

  return (
    <Grid container gap={1} sx={{ m: 1 }}>
      {filters.map(({ label, value, icon }) => {
        const isSelected = currentFilter === value;
        return (
          <Grid item key={label}>
            <Chip
              icon={icon}
              label={t(label)}
              onClick={() => handleSearchFilter(value)}
              className={isSelected ? "Mui-selected" : ""}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
